var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publications"},[_c('h1',{staticClass:"view-title"},[_vm._v("Publications")]),_vm._l((_vm.publications),function(publication){return _c('div',{key:publication.id},[_c('Publication',{attrs:{"publication":publication}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }